import PropTypes from 'prop-types';

import {
  ChildrenDefaultProps,
  ChildrenPropTypes,
} from '@/common/proptypes/Base/Children.proptypes';
import {
  DisabledDefaultProps,
  DisabledPropTypes,
} from '@/common/proptypes/Base/Disabled.proptypes';

export const NavLinkExtendedDefaultProps = {
  ...ChildrenDefaultProps,
  ...DisabledDefaultProps,
  activeClassName: 'active',
  context: null,
  disabledto: '#',
  onClick: () => null,
  to: '#',
};

export const NavLinkExtendedPropTypes = {
  ...ChildrenPropTypes,
  ...DisabledPropTypes,
  activeClassName: PropTypes.string,
  context: PropTypes.string,
  disabledto: PropTypes.string,
  onClick: PropTypes.func,
  to: PropTypes.oneOfType([PropTypes.shape({}), PropTypes.string]).isRequired,
};
